<div class="tcs-wrapper">
  <div class="tcs-header d-flex align-items-center justify-content-between">
    <h6 class="main-heading">{{ metricDisplayName }}</h6>
  </div>
  <div class="stat-grid stat-grid--3">
    <div class="stat-card" *ngFor="let item of statRow1">
      <div class="stat-icon-wrap" [style.background-color]="item.iconBg">
        <img [src]="item.icon" [alt]="item.label" class="stat-icon-img" />
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ item.value }}</span>
        <span class="stat-label">{{ item.label }}</span>
      </div>
    </div>
  </div>

  <div class="stat-grid stat-grid--2">
    <div class="stat-card" *ngFor="let item of statRow2">
      <div class="stat-icon-wrap" [style.background-color]="item.iconBg">
        <img [src]="item.icon" [alt]="item.label" class="stat-icon-img" />
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ item.value }}</span>
        <span class="stat-label">{{ item.label }}</span>
      </div>
    </div>
  </div>

  <!-- ── Feature Readiness Status ─────────────────────────── -->
  <h6 class="section-heading mt-3">Feature readiness status</h6>

  <div class="readiness-wrapper">
    <!-- Doughnut chart with center-text overlay -->
    <div class="chart-wrap">
      <app-pie-chart
        [chartType]="'doughnut'"
        [data]="chartData"
        [backgroundColors]="bgColors"
        [meta]="pieChartMeta"
      ></app-pie-chart>
      <div class="chart-center-text">{{ centerText }}</div>
    </div>

    <!-- Legend bars (right side) -->
    <div class="readiness-legend">
      <div class="legend-bar-item" *ngFor="let item of percentage">
        <div class="legend-bar-accent" [style.background-color]="item.color"></div>
        <div class="legend-bar-body">
          <span class="legend-bar-count">{{ item.value }}</span>
          <span class="legend-bar-label">{{ item.label }}</span>
        </div>
        <span class="legend-bar-pct">{{ item.percentage }}%</span>
      </div>
    </div>
  </div>

  <!-- ── Readiness Summary note ────────────────────────────── -->
  <div class="summary-box" *ngIf="data?.readiness_status_summary">
    <span class="summary-bullet">•</span>
    <span class="summary-text">{{ data.readiness_status_summary }}</span>
  </div>

</div>
